import { logger } from '../utils/logger';
import React from 'react';
import { Box, Container, Link as MuiLink, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { getBuildInfo } from '../utils/buildInfo';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const buildInfo = getBuildInfo();

  return (
    <Box component="footer" sx={{ borderTop: theme => `1px solid ${theme.palette.divider}`, pt: 3, pb: 3, mt: 4, backgroundColor: theme => theme.palette.background.paper }}>
      <Container maxWidth="lg">
        {/* Main footer content */}
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap' }}>
          <Typography variant="body2" color="text.secondary">
            © {currentYear} GoTruTax. All rights reserved.
          </Typography>
          <Box sx={{ display: 'flex', gap: { xs: 2, md: 3 }, flexWrap: 'wrap' }}>
            <MuiLink component={RouterLink} to="/products/advisor" variant="body2" color="text.secondary" underline="hover">
              Sales Tax Advisor
            </MuiLink>
            <MuiLink component={RouterLink} to="/resources/blogs-knowledge" variant="body2" color="text.secondary" underline="hover">
              Guides
            </MuiLink>
            <MuiLink component={RouterLink} to="/about/contact" variant="body2" color="text.secondary" underline="hover">
              Contact
            </MuiLink>
            <MuiLink component={RouterLink} to="/developers" variant="body2" color="text.secondary" underline="hover">
              Developers
            </MuiLink>
            <MuiLink component={RouterLink} to="/trust" variant="body2" color="text.secondary" underline="hover">
              Trust &amp; Accuracy
            </MuiLink>
            <MuiLink component={RouterLink} to="/tos" variant="body2" color="text.secondary" underline="hover">
              Terms of Service
            </MuiLink>
            <MuiLink component={RouterLink} to="/privacy-policy" variant="body2" color="text.secondary" underline="hover">
              Privacy Policy
            </MuiLink>
            <MuiLink component={RouterLink} to="/cookie-policy" variant="body2" color="text.secondary" underline="hover">
              Cookie Policy
            </MuiLink>
            <MuiLink
              component="button"
              type="button"
              variant="body2"
              color="text.secondary"
              underline="hover"
              onClick={() => window.dispatchEvent(new Event('gt:open-cookie-settings'))}
            >
              Cookie preferences
            </MuiLink>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;


